import { oids } from "@/configs/Settings";
import type { AutomationContext } from "../types";

export function buildAutomationAuthorReference(
  context: AutomationContext,
): string {
  return `Organization/${oids.cnpj}-${context.organizationId}`;
}

export function buildAutomationSourceReference(
  context: AutomationContext,
): string {
  return `Practitioner/${context.practitionerId}`;
}

export function normalizeSearchTerm(search?: string): string {
  if (!search) return "";
  return search.trim().toLocaleLowerCase();
}
